import { useContext, useState } from 'react'
import { DataGrid, GridColDef, GridCellParams } from '@mui/x-data-grid';
import clsx from 'clsx';
import AttToken from '../../services/AttToken';
import { Button, Skeleton, Switch, Typography } from '@mui/material';
import ModalEditarEmpresa from './ModalEditarEmpresa';
import { toast } from 'react-toastify';
import AddPathModal from './AddPathModal';
import EditIcon from '@mui/icons-material/Edit';
import { ptBR } from '@mui/x-data-grid/locales';
import { EmpresasContext, empresaType } from '../../context/EmpresasContext';
import Empresas from '../../services/Empresas';
import ModalWebhookAgendamento from './ModalWebhookAgendamento';

const empresaService = new Empresas();

export default function EmpressasCadastradas() {
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [openModalDominio, setOpenModalDominio] = useState<boolean>(false);
  const [openWebhookModal, setOpenWebhookModal] = useState<boolean>(false);
  const [webhookEmpresa, setWebhookEmpresa] = useState<empresaType | null>(null);
  const [blockButtons, setBlockButtons] = useState<boolean>(false);
  const [selectedEmpresa, setSelectedEmpresa] = useState<empresaType | null>(null);
  const { empresas: data, onLoading: loading, refetch } = useContext(EmpresasContext);

  const migraChamados = async (id: string, migrado: boolean) => {
    try {
      setBlockButtons(true);
      const token = await AttToken()
      if (token) {
        await empresaService.ligaDesligaMigracao(token, migrado, id);
        setBlockButtons(false);
        return refetch()
      }
    } catch (err) {
      return err
    }
  }

  const ligaDesligaPlano = async (id: string, migrado: boolean) => {
    try {
      setBlockButtons(true);
      const token = await AttToken()
      if (token) {
        await empresaService.concedeRetiraAcessoPlanoDeAcao(token, migrado, id);
        setBlockButtons(false);
        return refetch()
      }
    } catch (err) {
      return err
    }
  }

  async function migraGerencia(empresaId: string, migraGerencia: boolean) {
    try {
      setBlockButtons(true);
      const token = await AttToken()
      if (token) {
        await empresaService.migraGerencia(token, empresaId, migraGerencia);
        return (
          setBlockButtons(false),
          refetch()
        )
      }
    } catch (err) {
      return (
        setBlockButtons(false), {
          err,
        })
    }
  }

  const columns: GridColDef[] = [
    { field: 'nome', headerName: 'Empresa', width: 300 },
    { field: 'cnpj', headerName: 'CNPJ', width: 150 },
    {
      field: 'webhookAgendamento',
      headerName: 'Webhook de agendamento',
      sortable: false,
      width: 210,
      renderCell: (params: any) => (
        <Button
          variant="outlined"
          size="small"
          onClick={() => {
            const empresa = data.find((elem: empresaType) => elem.id === params.row.id);
            if (empresa) {
              setWebhookEmpresa(empresa);
              setOpenWebhookModal(true);
            }
          }}
          disabled={blockButtons}
        >
          Webhook de agendamento
        </Button>
      )
    },
    {
      field: 'dataCadastro',
      headerName: 'Data de Cadastro',
      width: 160,
      valueFormatter: (params: any) => {
        const dataFor = new Date(params).toLocaleString('pt-BR')
        return dataFor
      }
    },
    {
      field: 'status', headerName: 'Status', width: 65, type: 'string', cellClassName: (params: GridCellParams) => {
        return clsx('super-app', {
          positive: params.value === 'Ativo',
          negative: params.value === 'Inativo',
        });
      }
    },
    {
      field: 'dominio',
      headerName: 'Domínio',
      width: 220,
      align: 'center',
      renderCell: (params: any) => {
        if (params.row.dominio) {
          return (
            <Typography textAlign='center' fontSize='small'>{params.row.dominio}</Typography>
          )
        } else {
          return (
            <Button
              size='small'
              variant='contained'
              color='warning'
              onClick={(event) => {
                event.preventDefault();
                const empresa = data?.find((elem: empresaType) => elem.id === params.id)
                setSelectedEmpresa(empresa as empresaType)
                if (selectedEmpresa)
                  setOpenModalDominio(!openModalDominio)
              }}
              disabled={blockButtons}
            >
              Adicionar domínio /path
            </Button>
          )
        }
      }
    },
    {
      field: "edit",
      headerName: "Editar empresa",
      sortable: false,
      width: 175,
      renderCell: (params: any) => (
        <Button
          variant='outlined'
          size='small'
          endIcon={<EditIcon />}
          onClick={(event) => {
            event.preventDefault();
            const empresa = data.find((elem: empresaType) => elem.id === params.id)
            setSelectedEmpresa(empresa as empresaType)
            if (selectedEmpresa)
              setOpenModal(!openModal)
          }}
          disabled={blockButtons}
        >
          Editar empresa
        </Button>
      )
    },
    {
      field: "gerenciaMigrada",
      headerAlign: 'center',
      headerName: `Migrar gerencia(2.0)`,
      sortable: false,
      width: 180,
      renderCell: (params: any) => (
        <Switch
          sx={{
            "& .MuiSwitch-switchBase": {
              transitionDuration: "300ms",
              "&.Mui-checked": {
                transform: "translateX(26px)",
                color: "#fff",
                "& .MuiSwitch-thumb": {
                  backgroundColor: "#2EA689",
                },
              },
              "& .MuiSwitch-thumb": {
                backgroundColor: "#E74C3C",
              },
            },
          }}
          onChange={async () => {
            const gerenciaMigrada = typeof params.row.gerenciaMigrada === 'boolean' ? !params.row.gerenciaMigrada : true
            await toast.promise(migraGerencia(String(params.id), gerenciaMigrada), {
              pending: `Mudando empresa ${params.row.nome} para gerência ${!gerenciaMigrada ? 'Legado' : '2.0'}...`,
              success: `Empresa ${params.row.nome}, Agora usa gerência ${!gerenciaMigrada ? 'Legado' : '2.0'}`,
              error: 'Erro',
            })
          }} defaultChecked={params.row.gerenciaMigrada} color='success' disabled={blockButtons} />
      )
    },
    {
      field: "migrado",
      headerName: "Chamado/Notificações 2.0",
      sortable: false,
      width: 150,
      renderCell: (params: any) => (
        <Switch
          sx={{
            "& .MuiSwitch-switchBase": {
              transitionDuration: "300ms",
              "&.Mui-checked": {
                transform: "translateX(26px)",
                color: "#fff",
                "& .MuiSwitch-thumb": {
                  backgroundColor: "#2EA689",
                },
              },
              "& .MuiSwitch-thumb": {
                backgroundColor: "#E74C3C",
              },
            },
          }}
          onChange={async () => {
            setBlockButtons(true);
            const migrado = typeof params.row.migrado === 'boolean' ? !params.row.migrado : true
            await toast.promise(migraChamados(String(params.id), migrado), {
              pending: `Mudando empresa ${params.row.nome} para Chamados/Notificações ${!migrado ? 'Legado' : '2.0'}...`,
              success: `Empresa ${params.row.nome}, Agora usa Chamados/Notificações ${!migrado ? 'Legado' : '2.0'}`,
              error: 'Erro',
            })
          }} defaultChecked={params.row.migrado} color='success' disabled={blockButtons} />
      )
    },
    {
      field: "planoDeAcao",
      headerName: "Modulo de Plano de Ação",
      sortable: false,
      width: 180,
      renderCell: (params: any) => {
        return (
          <Switch
            sx={{
              "& .MuiSwitch-switchBase": {
                transitionDuration: "300ms",
                "&.Mui-checked": {
                  transform: "translateX(26px)",
                  color: "#fff",
                  "& .MuiSwitch-thumb": {
                    backgroundColor: "#2EA689",
                  },
                },
                "& .MuiSwitch-thumb": {
                  backgroundColor: "#E74C3C",
                },
              },
            }}
            onChange={async () => {
              setBlockButtons(true);
              const migrado = typeof params.row.planoDeAcao === 'boolean' ? !params.row.planoDeAcao : true
              await toast.promise(ligaDesligaPlano(String(params.id), migrado), {
                pending: `${!migrado ? 'Desligando' : 'Ligando'} Modulo de Planos de Ação para empresa ${params.row.nome}...`,
                success: `Modulo de Planos de Ação ${!migrado ? 'Desligado' : 'Ligado'} para empresa ${params.row.nome}`,
                error: 'Erro',
              })
            }} defaultChecked={params.row.planoDeAcao} color='success' disabled={blockButtons} />
        )
      }
    },
  ];

  return (
    <>
      {openModal
        && <ModalEditarEmpresa
          selectedEmpresa={selectedEmpresa as empresaType}
          openModal={openModal}
          setOpenModal={setOpenModal}
          setSelectedEmpresa={setSelectedEmpresa}
        />}
      {openModalDominio
        && <AddPathModal
          selectedEmpresa={selectedEmpresa as empresaType}
          openModalDominio={openModalDominio}
          setOpenModalDominio={setOpenModalDominio}
        />}
      {openWebhookModal && webhookEmpresa && <ModalWebhookAgendamento
        empresa={webhookEmpresa}
        open={openWebhookModal}
        onClose={() => {
          setOpenWebhookModal(false);
          setWebhookEmpresa(null);
        }}
      />}
      {
        loading
          ? <Skeleton height={900} width={'100%'} style={{ marginTop: '-12em' }} /> :
          <>
            {data ? <DataGrid
              rows={data?.map((elem: empresaType, index: number) => {
                return ({
                  id: elem.id,
                  nome: elem?.nome,
                  cnpj: elem?.cnpj,
                  dataCadastro: elem?.dataCadastro,
                  status: elem?.status === 'ativo' ? 'Ativo' : 'Inativo',
                  dominio: elem.dominio,
                  edit: elem.id,
                  gerenciaMigrada: elem.gerenciaMigrada,
                  formMigrado: elem?.formMigrado,
                  migrado: elem?.migrado,
                  planoDeAcao: elem?.planoDeAcao,
                  webhookAgendamento: elem.id

                })
              })}
              sx={{
                '& .super-app.negative': {
                  backgroundColor: '#F14668',
                  color: 'white',
                  textAlign: 'center'
                },
                '& .super-app.positive': {
                  backgroundColor: '#00D1B2',
                  color: 'white',
                  textAlign: 'center'
                },
              }}
              columns={columns}
              initialState={{
                pagination: {
                  paginationModel: { page: 0, pageSize: 10 },
                },
              }}
              pageSizeOptions={[10, 25]}
              localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
            /> : <div style={{ textAlign: 'center' }}>Não encontrou empresas cadastradas</div>}
          </>
      }
    </>
  )
}
